(function () {
  'use strict';

  angular.module('ringbaPortal')
    .component('resetPasswordV2', {
      controller: ResetPasswordV2Controller,
      controllerAs: 'vm',
      templateUrl: '/scripts/components/auth/v2/reset-passwordv2.view.html'
    });

  function ResetPasswordV2Controller(
    $stateParams,
    cacheService,
    whitelabelService
  ) {

    const vm = this;

    vm.pageTitle = 'Reset Password';
    vm.message = 'Please enter a new password';
    vm.isWhitelabeledSite = false;

    vm.$onInit = onInit;

    function onInit() {
      _checkPreviewMode();
      vm.token = $stateParams.t;
      vm.resetId = $stateParams.u;
      vm.isWhitelabeledSite = !whitelabelService.checkLocationHostIsBase() || $stateParams.preview == 'true';
    }

    function _checkPreviewMode() {
      if ($stateParams.preview) {
        vm.previewModeEnabled = true;
        vm.currentTheme = cacheService.get('pw-preview');
        vm.isLightTheme = vm.currentTheme.isLightTheme;
        cacheService.remove('pw-preview');
      }
    }
  }
})();
